export const roundFixed = (x: number, fractionDigits?: number): number => {
  if (x == null) {
    return x;
  }

  if (isNaN(x)) {
    return null;
  }

  const mult = fractionDigits ? 10 ** fractionDigits : 1;
  return Math.sign(x) * Math.round(Math.abs(x) * mult) / mult;
};

export const firstFloatLessThanOrEqual = (x: number, y: number, fractionDigits?: number): boolean => {
  if (x == null) {
    return false;
  }
  if (y == null) {
    return false;
  }
  const factor = Math.pow(10, fractionDigits);
  const _x = Math.round(x * factor) / factor;
  const _y = Math.round(y * factor) / factor;
  return _x <= _y;
};

/** Find the smallest number in ar that is > x.  If no such number, return x. */
export const findMinLarger = (ar: number[], x: number): number => {
  ar = ar.filter((c) => c > x);
  return ar.length ? Math.min(...ar) : x;
};

/** Find the largest number in ar that is < x.  If no such number, return x. */
export const findMaxSmaller = (ar: number[], x: number): number => {
  ar = ar.filter((c) => c < x);
  return ar.length ? Math.max(...ar) : x;
};
